import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  token: null,
  refreshToken: null,
  user: null,
  role: null,
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload
    },
    setRole: (state, action) => {
      state.role = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
      state.isAuthenticated = !!action.payload
    },
    logout: (state) => {
      state.token = null
      state.refreshToken = null
      state.user = null
      state.role = null
      state.isAuthenticated = false
    },

  }
})

export const { setRefreshToken, setUser, setToken, setRole, logout } = authSlice.actions

// Selectors
export const getUser = (state) => state.auth.user
export const getToken = (state) => state.auth.token
export const getRefreshToken = (state) => state.auth.refreshToken
export const getIsAuthenticated = (state) => state.auth.isAuthenticated
export const getRole = (state) => state.auth.role

export default authSlice.reducer

